import { computed, ref } from 'vue'

import { defineStore } from 'pinia'

import type { Filter, FilterGroup } from '@/types/Filters'

const defaultFilters: Filter[] = []

export default defineStore('filters', () => {
  const filtersOpen = ref(false)
  const searchText = ref('')
  const initialFilters = ref(null as FilterGroup[] | null)
  const filters = ref<Filter[]>(defaultFilters.slice())

  function resetFilters() {
    filters.value = defaultFilters.slice()
  }

  const isFiltered = computed(() => {
    return !!filters.value.length
  })

  return { resetFilters, filtersOpen, filters, isFiltered, initialFilters, searchText }
})
